export default __webpack_public_path__ + "components/weather-icon/static/daylightrain@3-260eb94e9b2dd77a2b04b209f2b46d22.png";